<template>
  <div class="m-2">
    <h4 v-if="!researchAdvisor.id">
      {{ $t('Research advisor not found.') }}
    </h4>
    <hr>
    <b-form @submit.prevent>
      <validation-observer ref="researchAdvisorCreate">
        <b-row>
          <b-col md="6">
            <b-form-group
              :label="$t('First name')"
              label-for="first_name"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('First name')"
                rules="required"
              >
                <b-form-input
                  id="first_name"
                  v-model="user.first_name"
                  :placeholder="$t('First name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              :label="$t('Surname')"
              label-for="surname"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Surname')"
                rules="required"
              >
                <b-form-input
                  id="surname"
                  v-model="user.sur_name"
                  :placeholder="$t('Surname')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Middle name')"
              label-for="mid_name"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Middle name')"
                rules="required"
              >
                <b-form-input
                  id="mid_name"
                  v-model="user.mid_name"
                  :placeholder="$t('Middle name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Birthday')"
              label-for="birth_date"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Birthday')"
                rules="required"
              >
                <flat-pickr
                  id="birth_date"
                  v-model="user.birth_date"
                  class="form-control"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Birth place')"
              label-for="birth_place"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Birth place')"
                rules="required"
              >
                <div class="form-label-group">
                  <b-form-input
                    id="birth_place"
                    v-model="user.birth_place"
                    :placeholder="$t('Birth place')"
                  />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Citizenship')"
              label-for="citizenship"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Citizenship')"
                rules="required"
              >
                <div class="form-label-group">
                  <b-form-input
                    id="citizenship"
                    v-model="user.ctzn"
                    :placeholder="$t('Citizenship')"
                  />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Gender')"
              label-for="gender"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Gender')"
                rules="required"
              >
                <b-form-select
                  id="gender"
                  v-model="user.gd"
                  :options="genders"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Nationality')"
              label-for="natn"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Nationality')"
                rules="required"
              >
                <div class="form-label-group">
                  <b-form-input
                    id="natn"
                    v-model="user.natn"
                    :placeholder="$t('Nationality')"
                  />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Country')"
              label-for="country"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Country')"
                rules="required"
              >
                <div class="form-label-group">
                  <b-form-input
                    id="country"
                    v-model="user.country"
                    :placeholder="$t('Country')"
                  />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Electronic digital signature')"
              label-for="Electronic_digital_signature"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Electronic digital signature')"
                rules="required"
              >
                <b-form-select
                  id="Electronic_digital_signature"
                  v-model="user.valid"
                  :options="digitalSignature"
                  field="id"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Permanent address')"
              label-for="per_adr"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Permanent address')"
                rules="required"
              >
                <div class="form-label-group">
                  <b-form-input
                    id="per_adr"
                    v-model="user.per_adr"
                    :placeholder="$t('Permanent address')"
                  />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('PNFL')"
              label-for="pin"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('PNFL')"
                rules="required"
              >
                <div class="form-label-group">
                  <b-form-input
                    id="pin"
                    v-model="user.pin"
                    :placeholder="$t('PNFL')"
                  />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Tin')"
              label-for="stir"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Tin')"
                rules="integer"
              >
                <div class="form-label-group">
                  <b-form-input
                    id="stir"
                    v-model="user.tin"
                    type="number"
                    :placeholder="$t('Tin')"
                  />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Email')"
              label-for="email"
              type="email"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Email')"
                rules=""
              >
                <div class="form-label-group">
                  <b-form-input
                    id="email"
                    v-model="user.email"
                    :placeholder="$t('Email')"
                  />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Validity of the passport')"
              label-for="validity_of_the_passport"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Validity of the passport')"
                rules="required"
              >
                <flat-pickr
                  id="validity_of_the_passport"
                  v-model="user.pport_expr_date"
                  class="form-control"
                  :locale="$i18n.locale"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Date of passport issuance')"
              label-for="date_of_passport_issuance"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Date of passport issuance')"
                rules="required"
              >
                <flat-pickr
                  id="date_of_passport_issuance"
                  v-model="user.pport_issue_date"
                  class="form-control"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Who issued the passport')"
              label-for="Who_issued_the_passport"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Who issued the passport')"
                rules="required"
              >
                <b-form-input
                  id="Who_issued_the_passport"
                  v-model="user.pport_issue_place"
                  :placeholder="$t('Who issued the passport')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Passport series and number')"
              label-for="Passport_series_and_number"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Passport series and number')"
                rules="required"
              >
                <b-form-input
                  id="Passport_series_and_number"
                  v-model="user.pport_no"
                  :placeholder="$t('Passport series and number')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Mobile phone')"
              label-for="mob_phone_no"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Mobile phone')"
                rules="required"
              >
                <b-form-input
                  id="mob_phone_no"
                  v-model="user.mob_phone_no"
                  :placeholder="$t('Mobile phone')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              :label="$t('Scientific title')"
              label-for="scientific_title"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Scientific title')"
                :rules="canEditAcademicData ? 'required' : ''"
              >
                <v-select
                  id="scientific_title"
                  v-model="user.scientific_title"
                  :disabled="!canEditAcademicData"
                  :reduce="(option) => option.id"
                  :options="scientificTitles"
                  :get-option-label="(option) => $langName(option.name)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              :label="$t('Scientific degree')"
              label-for="scientific_degree"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Scientific degree')"
                :rules="canEditAcademicData ? 'required' : ''"
              >
                <v-select
                  id="scientific_degree"
                  v-model="user.scientific_degree"
                  :disabled="!canEditAcademicData"
                  :reduce="(option) => option.id"
                  :options="scientificDegrees"
                  :get-option-label="(option) => $langName(option.name)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('User Type')"
              label-for="user_type"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('User type')"
                rules="required"
              >
                <v-select
                  id="user_type"
                  v-model="user.user_type"
                  :reduce="(option) => option.type"
                  :options="userTypes"
                  :get-option-label="(option) => $langName(option.name)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <b-col
            class="d-flex justify-content-end align-items-end"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mr-1"
              type="submit"
              variant="primary"
              @click="submit"
            >
              {{ researchAdvisor.id ? $t('Update') : $t('Create') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              variant="outline-secondary"
            >
              {{ $t('Reset') }}
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BFormSelect,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { required, integer } from '@/libs/validations/validations'

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    flatPickr,
  },
  data() {
    return {
      required,
      integer,
    }
  },
  computed: {
    researchAdvisor: {
      get() {
        return this.$store.state.researchAdvisor.researchAdvisor
      },
      set(data) {
        this.$store.commit('researchAdvisor/UPDATE', data)
      },
    },
    user() {
      return this.researchAdvisor.user
    },
    isForeignAdvisor() {
      return this.user && this.user.foreign_user === true
    },
    canEditAcademicData() {
      return !this.researchAdvisor.id || this.isForeignAdvisor
    },
    scientificDegrees() {
      return this.$store.state.staticModule.scientificDegrees
    },
    userTypes() {
      return this.$store.state.staticModule.userTypes
    },
    scientificTitles() {
      return this.$store.state.staticModule.scientificTitles
    },
    digitalSignature() {
      return [
        {
          value: true,
          text: this.$t('Yes'),
        },
        {
          value: false,
          text: this.$t('No'),
        },
      ]
    },
    genders() {
      return [
        {
          value: 1,
          text: this.$t('Male'),
        },
        {
          value: 2,
          text: this.$t('Female'),
        },
      ]
    },
  },
  created() {
    localize(this.$i18n.locale)
    this.$store.dispatch('staticModule/scientificTitle')
    this.$store.dispatch('staticModule/scientificDegree')
  },
  setup() {
    const MODULE_NAME = 'researchAdvisor'
    return {
      MODULE_NAME,
    }
  },
  methods: {
    clear() {
      this.$store.commit('researchAdvisor/FRESH')
      this.$refs.researchAdvisorCreate.reset()
    },
    submit() {
      this.$refs.researchAdvisorCreate.validate().then(success => {
        if (success) {
          delete this.user.full_name
          this.$createSwal(this, this.researchAdvisor, `researchAdvisor/${this.researchAdvisor.id ? 'update' : 'createAdvisor'}`, () => {
            this.clear()
            this.$emit('refetchData')
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
